<template>
  <v-dialog v-model="open" persistent :max-width="dialogType == 'textarea' ? '800px' : '500px'">
    <v-card>
      <v-card-title>
        <span>{{ dialogTitle }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex>
            <form>
              <v-text-field
                v-if="dialogType == 'text'"
                :data-vv-name="fieldName"
                data-vv-validate-on="blur"
                :ref="'input_' + fieldName"
                :label="inputLabel"
                v-model="inputValue"
                color="clr-primary"
                :counter="counter"
                v-validate="veeValidate"
                :error-messages="getMessage(fieldName)"
                :required="required"
                :disabled="onSending"
              ></v-text-field>
              <v-select
                v-if="dialogType == 'select'"
                :data-vv-name="fieldName"
                :items="items"
                :item-text="itemText"
                :item-value="itemValue"
                :ref="'input_' + fieldName"
                :label="inputLabel"
                v-model="inputValue"
                color="clr-primary"
                v-validate="veeValidate"
                :error-messages="getMessage(fieldName)"
                :required="required"
                :disabled="onSending"
              ></v-select>
              <v-textarea
                auto-grow
                v-if="dialogType == 'textarea'"
                :data-vv-name="fieldName"
                data-vv-validate-on="blur"
                :ref="'input_' + fieldName"
                :label="inputLabel"
                v-model="inputValue"
                color="clr-primary"
                v-validate="veeValidate"
                :error-messages="getMessage(fieldName)"
                :disabled="onSending"
                :counter="counter"
              ></v-textarea>
            </form>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="close" :disabled="onSending">{{ $T('button.close') }}</v-btn>
        <v-btn color="clr-btn" flat @click.native="save" :disabled="!isSavable" :loading="loading">{{
          $T('button.save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: { type: Boolean, required: true },
    dialogKey: { type: String, required: true },
    dialogType: { type: String, required: true },
    dialogTitle: { type: String, required: true },
    fieldName: { type: String, required: true },
    inputLabel: { type: String, required: true },
    initValue: { type: String, required: false },
    items: { type: Array, required: false },
    itemValue: { type: String, required: false },
    itemText: { type: String, required: false },
    veeValidate: { type: String, required: true },
    required: { type: Boolean, required: false },
    counter: { type: Number, required: false },
    apiErrors: { type: Object, required: true },
    onSending: { type: Boolean, required: true },
  },
  data() {
    return {
      inputValue: this.initValue,
      loading: !this.open,
    };
  },
  computed: {
    isSavable() {
      return this.isFormDirty && !this.isFormInValid && !this.onSending;
    },
    isFormDirty() {
      return Object.keys(this.fields).some(key => this.fields[key].dirty);
    },
    isFormInValid() {
      return Object.keys(this.fields).some(key => this.fields[key].invalid);
    },
  },
  methods: {
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
    addError(fieldName, value, msg) {
      if (!this.apiErrors) this.apiErrors = {};
      if (!this.apiErrors[fieldName]) this.apiErrors[fieldName] = {};
      this.apiErrors[fieldName][value] = msg;
      this.reValidate();
    },
    reValidate() {
      this.$validator.validateAll();
      this.$refs['input_' + this.fieldName].focus();
      this.loading = false;
    },
    close() {
      this.dialog = false;
      this.$emit('close', this.dialogKey);
    },
    save() {
      this.loading = true;
      var _self = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          _self.$emit('save', _self.dialogKey, _self.inputValue, _self.initValue);
        } else {
          _self.loading = false;
          console.warn('there is invalid values.');
        }
      });
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
</style>
